import React from "react";
import { useSelectContext } from "./Select";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "../Tooltip";

const useStyles = makeStyles(() => ({
  item: {
    cursor: "pointer",
    borderRadius: "4px",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#F8F8F8",
    },
  },
  selected: {
    backgroundColor: "#EDEDED",
  },
  danger: {
    color: "#D84949",
    "&:hover": {
      backgroundColor: "#F8F8F8",
    },
  },
  dangerSelected: {
    backgroundColor: "#EDEDED",
    color: "#D84949",
  },
  disabled: {
    opacity: 0.45,
    cursor: "not-allowed",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

const SelectItem = ({ value, children, searchText, variant = "default", disabled = false, disabledTooltip }) => {
  const { selectValue, value: selectedValue, searchable, searchTerm, sizeMeasurements } = useSelectContext();
  const classes = useStyles();
  const isSelected = value === selectedValue;

  // If searchable is enabled and there's a search term, filter items
  const itemText = searchText || (typeof children === "string" ? children : "");
  const shouldShow = !searchable || !searchTerm || itemText.toLowerCase().includes(searchTerm.toLowerCase()) || (value && value.toString().toLowerCase().includes(searchTerm.toLowerCase()));

  if (!shouldShow) {
    return null;
  }

  // Determine the CSS class based on variant and selection state
  const getItemClass = () => {
    if (disabled) {
      return `${classes.item} ${classes.disabled}`;
    }
    if (variant === "danger") {
      return `${classes.item} ${classes.danger} ${isSelected ? classes.dangerSelected : ""}`;
    }
    return `${classes.item} ${isSelected ? classes.selected : ""}`;
  };

  const itemContent = (
    <div className={getItemClass()} onClick={disabled ? undefined : () => selectValue(value)} style={{ padding: sizeMeasurements.padding }} data-select-item data-disabled={disabled ? "true" : undefined}>
      {children}
    </div>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip content={disabledTooltip} placement="top" fullwidth>
        {itemContent}
      </Tooltip>
    );
  }

  return itemContent;
};

export default SelectItem;
